<template>
  <div class="notices is-top">
    <div role="alertdialog" v-for="(alert, idx) in alerts" :key="idx" class="snackbar is-top edl-snackbar" :class="getSnacbarType(alert.type)">
      <div class="text edl-snackbar">
        <div class="columns is-desktop is-mobile is-gapless is-vcentered">
          <div class="column is-narrow" style="margin-top: 7px; margin-right: 16px;">
            <circle-check-green-icon v-if="alert.type === 'success'" />
            <circle-exclamation-red-icon v-else />
          </div>
          <div class="column is-10">{{ alert.message }}</div>
          <div class="column is-1">
            <a href="#" @click.prevent="removeAlert(alert.key)" class="is-pulled-right" :class="getCloseTextType(alert.type)">
              <i class="fas fa-times"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CircleCheckGreenIcon from '~/components/atoms/icons/CircleCheckGreenIcon'
import CircleExclamationRedIcon from '~/components/atoms/icons/CircleExclamationRedIcon'

export default {
  components: { CircleCheckGreenIcon, CircleExclamationRedIcon },

  props: {
    message: {
      type: String,
      default: 'Message here'  
    },
    alerts: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    ...mapActions({
      removeAlert: 'notifications/removeAlert',
    }),
    getSnacbarType(type) {
      if (type === 'success') {
        return 'is-success'
      } else if (type === 'danger') {
        return 'is-danger'
      } else {
        return ''
      }
    },
    getCloseTextType(type) {
      if (type === 'success') {
        return 'has-text-primary'
      } else if (type === 'danger') {
        return 'has-text-red'
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped>
.edl-snackbar {
  width: 100%;
  border-radius: 8px !important;
  box-sizing: border-box;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
}

.edl-snackbar.is-success {
  background: #F7FDF7;
  color: #279B24 !important;
  border: 1px solid #279B24;
}

.edl-snackbar.is-danger {
  background: #FFEEE9;
  color: #EB5757;
  border: 1px solid #EB5757;
}

.edl-snackbar-close {
  cursor: pointer;
}
</style>
